import imgInside4 from "@/assets/images/screens/homepage/gallery-inside-4.jpg";
import imgInside5 from "@/assets/images/screens/homepage/gallery-inside-5.jpg";
import imgInside3 from "@/assets/images/screens/homepage/gallery-inside-3.jpg";
import imgOutside1 from "@/assets/images/screens/homepage/gallery-outside-1.jpg";
import imgOutside2 from "@/assets/images/screens/homepage/gallery-outside-2.jpg";
import imgOutside3 from "@/assets/images/screens/homepage/gallery-outside-3.jpg";
import imgOutside4 from "@/assets/images/screens/homepage/gallery-outside-4.jpg";
import imgOutside6 from "@/assets/images/screens/homepage/gallery-outside-6.jpg";
import imgConstruction20261022n1 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-1.jpg";
import imgConstruction20261022n2 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-2.jpg";
import imgConstruction20261022n3 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-3.jpg";
import imgConstruction20261022n4 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-4.jpg";
import imgConstruction20261022n5 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-5.jpg";
import imgConstruction20261022n6 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-6.jpg";
import imgConstruction20261022n7 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-7.jpg";
import imgConstruction20261022n8 from "@/assets/images/screens/homepage/construction/construction-2026-10-22-8.jpg";
import IconHouse from "@/components/icons/IconHouse";
import { GalleryImageType, GalleryType } from "@/types/GalleryType";

const image = (src: GalleryImageType["original"]): GalleryImageType => ({
  original: src,
  thumbnail: src,
});

export default function getGalleryData(): Array<GalleryType> {
  return [
    {
      id: "visualizations",
      name: "Wizualizacje",
      icon: null,
      images: [
        image(imgOutside1),
        image(imgOutside2),
        image(imgOutside3),
        image(imgOutside4),
        image(imgOutside6),
        image(imgInside4),
        image(imgInside5),
        image(imgInside3),
      ],
    },
    {
      id: "construction",
      name: "Zdjęcia z budowy",
      icon: <IconHouse className="mr-2.5 hidden w-8 sm:block" />,
      images: [],
      // Newest first. Add each new photo shoot as another entry.
      sessions: [
        {
          id: "2026-10-22",
          date: "2026-10-22",
          images: [
            image(imgConstruction20261022n1),
            image(imgConstruction20261022n2),
            image(imgConstruction20261022n3),
            image(imgConstruction20261022n4),
            image(imgConstruction20261022n5),
            image(imgConstruction20261022n6),
            image(imgConstruction20261022n7),
            image(imgConstruction20261022n8),
          ],
        },
      ],
    },
  ];
}
